import { atom } from "recoil";
import { IHierarchyDetails } from "../types";

export const hierarchyTypeState = atom({
  key: "hierarchyTypeState",
  default: "",
});

export const hierarchyTypeModalState = atom({
  key: "hierarchyTypeModalState",
  default: false,
});

export const hierarchyFormModal = atom({
  key: "hierarchyFormModal",
  default: false,
});

export const hierarchyFormModalState = atom({
  key: "hierarchyFormModalState",
  default: false,
});

export const isAddHierarchy = atom({
  key: "isAddHierarchy",
  default: false,
});

export const isEditHierarchy = atom({
  key: "isEditHierarchy",
  default: false,
});

export const hierarchyShowState = atom({
  key: "hierarchyShowState",
  default: false,
});

export const hierarchyIds = atom({
  key: "hierarchyIds",
  default: null,
});

export const rowForEditHierarchy = atom<IHierarchyDetails | undefined>({
  key: "rowForEditHierarchy",
  default: undefined,
});

export const hierarchyFilteredData = atom({
  key: "hierarchyFilteredData",
  default: {
    hierarchyName: "",
    hierarchyTypeName: "",
    hierarchyId: "",
    hierarchyTypeId: "",
  },
});

export const showHierarchyTable = atom({
  key: "showHierarchyTable",
  default: false,
});
